import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import styled from '@emotion/styled';
import {
  Button,
  ButtonBase,
  FormControl,
  FormGroup,
  FormLabel,
  Popover
} from '@material-ui/core';
import React, { useRef, useState } from 'react';
import { SelectorChip } from '../SelectorChip';

export type SingleSelectorOption<T> = {
  label: React.ReactNode;
  value: T;
};

type Props<T> = {
  value: T | null | undefined;
  onChange: (nextValue: T) => void;
  options: SingleSelectorOption<T>[];
  children: React.ReactNode;
  legend?: React.ReactNode;
  minMenuWidth?: string | number;
};

const Label = styled('div')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const SingleSelectorChip = SelectorChip;

export const SingleSelector = <T extends unknown>({
  value,
  onChange,
  options,
  children,
  legend,
  minMenuWidth = 150
}: Props<T>) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLButtonElement>(null);
  return (
    <>
      <ButtonBase onClick={() => setOpen((x) => !x)} ref={ref}>
        {children}
      </ButtonBase>
      <Popover
        open={open}
        onClose={() => setOpen(false)}
        anchorEl={ref.current}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left'
        }}
      >
        <FormControl
          component="fieldset"
          className={css({
            margin: theme.spacing(2),
            minWidth: minMenuWidth
          })}
        >
          {legend && (
            <FormLabel
              classes={{
                root: css({
                  padding: theme.spacing(1)
                })
              }}
              component="legend"
            >
              {legend}
            </FormLabel>
          )}
          <FormGroup>
            {options.map((o, i) => (
              <Button
                key={i}
                onClick={() => {
                  onChange(o.value);
                  setOpen(false);
                }}
              >
                <Label>{o.label}</Label>
              </Button>
            ))}
          </FormGroup>
        </FormControl>
      </Popover>
    </>
  );
};
